module.exports = __webpack_public_path__ + "static/img/mp3.4d0f8520.png";